const dummy_t = (translationKey) => translationKey;

export default [
  {
    path: '/how-to',
    translationKey: dummy_t('footer.serviceAccess'),
  },
  {
    path: '/terms-of-service',
    translationKey: dummy_t('footer.tos'),
  },
  {
    path: '/privacy-policy',
    translationKey: dummy_t('footer.privacyPolicy'),
  },
  {
    externalPath: {
      'en-US': 'https://dtbaen.zendesk.com/hc/en-us',
      'pl-PL': 'https://faq.dieta.hpba.pl/hc/pl',
    },
    translationKey: dummy_t('footer.contact'),
  },
];
